<template>
    <div>
        <div class="loading" v-if="loading">
            <v-progress-circular indeterminate color="#de5d0a"></v-progress-circular>
        </div>
        <div class="containers" v-else>
            <div class="payment">
                <div style="">
                    <!-- border-bottom: 1px solid #C6C6C6; -->
                    <div class="cancel-booking-orderId"
                        style=" padding-bottom: 16px; border-bottom: #DADDE1 1px solid;">
                        <div class="cancel-booking" @click="cancelBooking">
                            {{ $t('message.cancelBooking') }}
                        </div>
                    </div>
                    <div class="row mt-8" style="position: relative; margin: 0%;">
                        <div v-html="paymentFormPost" style="display: none;"></div>
                        <div class="col-lg-5 col-md-5 col-sm-12 left-col">
                            <div class="row"
                                style="border: #DADDE1 1px solid; border-radius: 8px; opacity: 1; z-index: 100;">
                                <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 16px;">
                                    <div class="left">
                                        <div class="trip-sum">{{ $t('message.tripsummary') }}</div>
                                        <div class="all-info" style="font-weight: 600;">{{ $t('message.billingDetail')
                                            }}</div>
                                        <div class="row" style="flex-wrap: nowrap;">
                                            <div class="col-lg-4 col-md-4 col-sm-4"
                                                style="display: flex; flex-direction: column; padding-right: 0%; width: 30%;">
                                                <span class="all-info">{{ $t('message.orderId') }}</span>
                                                <span v-if="getEmail()" class="all-info" style="white-space: nowrap;">{{
                                                    $t('message.email') }}</span>
                                                <span v-if="tleFalse" class="all-info">{{ $t('message.phoneNumber')
                                                    }}</span>
                                            </div>
                                            <div style="display: flex; flex-direction: column;width: 70%;"
                                                class="col-lg-8 col-md-8 col-sm-8">
                                                <span class="all-info"> : {{ transactionId }}</span>
                                                <span v-if="getEmail()" class="all-info" style="word-wrap: break-word;">
                                                    : {{ getEmail()
                                                    }}</span>
                                                <span v-if="tleFalse" class="all-info"> : {{ getPhone() }}</span>
                                            </div>
                                        </div>
                                        <!-- <hr> -->
                                        <div class="all-info" style="border-top: 1px solid #C6C6C6;"></div>
                                        <div>

                                        </div>
                                        <div class="all-info">{{ getDestinationFrom() }} - {{ getdestinationToName() }}
                                        </div>
                                        <div class="row" style="flex-wrap: nowrap;">
                                            <div class="col-lg-4 col-md-4 col-sm-4"
                                                style="display: flex; flex-direction: column; padding-bottom: 0%;">
                                                <span class="all-info">{{ $t('message.vehicleType') }}</span>
                                                <span class="all-info">{{ $t('message.departure') }}</span>
                                            </div>
                                            <div class="col-lg-7 col-md-7 col-sm-7"
                                                style="display: flex; flex-direction: column; padding-bottom: 0%;">
                                                <span class="all-info"> : {{ getTransportationType() }} </span>
                                                <span class="all-info"> : {{ getDateFrom() }}, at {{
                                                    convertTimes(getDeparture()) }}</span>
                                            </div>
                                        </div>
                                        <div class="row" style="" v-for="(seat, index) in getSeatNum()" :key="index">
                                            <!-- <div  class="dotted"> -->
                                            <img v-if="index != 0" style="width: 100%; padding: 0px 1rem 0px 12px;"
                                                src="@/assets/Line112.png" alt="">
                                            <!-- <div style="border-top: 1px solid #C6C6C6; width: 100%;"></div> -->
                                            <!-- <hr> -->
                                            <!-- </div> -->
                                            <div class="col-lg-4 col-md-4 col-sm-4"
                                                style="display: flex; flex-direction: column; padding-top: 0%;">
                                                <span class="all-info">{{ getseatType() == 2 ? $t('message.bedno') :
                                                    $t('message.seatno') }}</span>
                                                <span class="all-info">{{ $t('message.gender') }}</span>
                                                <span class="all-info">{{ $t('message.nationality') }} </span>
                                            </div>
                                            <div class="col-lg-7 col-md-7 col-sm-7"
                                                style="display: flex; flex-direction: column; padding-top: 0%;">
                                                <span class="all-info">: {{ getSeatLabel()[index] }}</span>
                                                <span class="all-info">: {{ getGender()[index] }}</span>
                                                <span class="all-info">: {{ getNationality()[index] }}</span>
                                            </div>
                                        </div>
                                        <div v-if="returnTrip">
                                            <div class="all-info" style="border-top: 0.4px solid #C6C6C6;"></div>
                                            <div class="" s>

                                            </div>
                                            <div class="all-info">{{ getdestinationToName() }} - {{ getDestinationFrom()
                                                }}
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4"
                                                    style="display: flex; flex-direction: column; ">
                                                    <span class="all-info">{{ $t('message.vehicleType') }} </span>
                                                    <span class="all-info">{{ $t('message.departure') }} </span>
                                                </div>
                                                <div class="col-lg-7 col-md-7 col-sm-7"
                                                    style="display: flex; flex-direction: column;">
                                                    <span class="all-info"> : {{ getTransportationTypeBack() }}</span>
                                                    <span class="all-info"> : {{ getDateTo() }}, at {{
                                                        convertTimes(getDepartureBack()) }}</span>
                                                </div>
                                            </div>
                                            <div class="row" v-for="(seat, index) in getSeatNumBack()" :key="index"
                                                style="margin-top: 0%;">
                                                <img v-if="index != 0"
                                                    style="width: 100%; padding: 0px 1rem 0px 12px; margin-top: 1rem;"
                                                    src="@/assets/Line112.png" alt="">
                                                <div class="col-lg-4 col-md-4 col-sm-4"
                                                    style="display: flex; flex-direction: column; padding-top: 0%;">
                                                    <span class="all-info">{{ getseatTypeBack() == 2 ?
                                                        $t('message.bedno') : $t('message.seatno') }}</span>
                                                    <span class="all-info">{{ $t('message.gender') }}</span>
                                                    <span class="all-info">{{ $t('message.nationality') }}</span>
                                                </div>
                                                <div class="col-lg-7 col-md-7 col-sm-7"
                                                    style="display: flex; flex-direction: column; padding-top: 0%;">

                                                    <span class="all-info">: {{ getSeatLabelBack()[index] }}</span>
                                                    <span class="all-info">: {{ getGenderBack()[index] }}</span>
                                                    <span class="all-info">: {{ getNationalityBack()[index] }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="all-info" v-if="getTotalLuckeydraw() != 0">Lucky Ticket: $   {{ getTotalLuckeydraw() }}</div> -->
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-1 col-md-1 col-sm-12 min-col"></div>
                        <div class="col-lg-6 col-md-5 col-sm-12 right-col" style="padding: 0px">
                            <div class="passDetails">
                                <!-- <div class="number">1</div> -->
                                <div class="title-pass">{{ $t('message.paymentMethod') }}</div>
                            </div>
                            <!-- <div style="font-size: 16px;font-weight: 500;margin-top: 20px;">{{$t('message.choosePaymentMethod') }}</div> -->
                            <!-- <form action=""> -->
                            <div class="select-radio">
                                <v-radio-group v-model="radioGroup" style="margin-top: 0%;">
                                    <div class="card-select-payment" :class="{ 'card-active': radioGroup === 5 }"
                                        @click="radioGroup = 5" style="cursor: pointer;">
                                        <div class="img-card">
                                            <img src="@/assets/KHQR.svg" alt="">
                                        </div>
                                        <div class="text">
                                            <div class="title" style="line-height: 20px;">
                                                {{ $t('message.abakhqr') }}
                                            </div>
                                            <div class="txt">
                                                {{ $t('message.desabakhqr') }}
                                            </div>
                                        </div>
                                        <div class="radios">
                                            <v-radio class="payment-radio" color="#DE5D0A" :value="5"></v-radio>
                                        </div>
                                    </div>
                                    <div class="card-select-payment" :class="{ 'card-active': radioGroup === 4 }"
                                        @click="radioGroup = 4" style="cursor: pointer;">
                                        <div class="img-card">
                                            <img src="@/assets/wing_back_pay.jpg"
                                                style="width: 40px;height: 30px;border-radius: 4px;" alt="">
                                        </div>
                                        <div class="text">
                                            <div class="title" style="line-height: 20px;">
                                                {{ $t("message.wingBank") }}
                                            </div>
                                            <div class="txt">
                                                {{ $t('message.desWingBank') }}
                                            </div>
                                        </div>
                                        <div class="radios">
                                            <v-radio class="payment-radio" color="#DE5D0A" :value="4"></v-radio>
                                        </div>
                                    </div>
                                    <div class="card-select-payment" :class="{ 'card-active': radioGroup === 8 }"
                                        @click="radioGroup = 8" style="cursor: pointer;">
                                        <div class="img-card">
                                            <img src="@/assets/ACLEDA_PAY.svg" alt="">
                                        </div>
                                        <div class="text">
                                            <div class="title" style="line-height: 20px;">
                                                {{ $t("message.acleda") }}
                                            </div>
                                            <div class="txt">
                                                {{ $t('message.acledascan') }}
                                            </div>
                                        </div>
                                        <div class="radios">
                                            <v-radio class="payment-radio" color="#DE5D0A" :value="8"></v-radio>
                                        </div>
                                    </div>
                                    <div class="card-select-payment" :class="{ 'card-active': radioGroup === 6 }"
                                        @click="radioGroup = 6" style="cursor: pointer;">
                                        <div class="img-card">
                                            <img src="@/assets/generic.svg" alt="">
                                        </div>
                                        <div class="text">
                                            <div class="title">
                                                {{ $t('message.creditDebitCard') }}
                                            </div> 
                                            <div class="txt" style="line-height: 1;">
                                                <img src="@/assets/4_Cards.svg" alt="">
                                            </div>
                                        </div>
                                        <div class="radios">
                                            <v-radio class="payment-radio" color="#DE5D0A" :value="6"></v-radio>
                                        </div>
                                    </div>
                                </v-radio-group>
                            </div>

                            <!-- <div class="all-payment">
                            <div class="type-payment">{{ $t('message.paymentMethod') }}:</div>
                            <div class="price-payment">
                                <span class="all-style" v-if="radioGroup == 4">{{ $t('message.wingBank') }}</span>
                                <span class="all-style" v-if="radioGroup == 5">{{ $t('message.abakhqr') }}</span>
                                <span class="all-style" v-if="radioGroup == 6">{{ $t('message.creditDebitCard')
                                    }}</span> -->
                            <!-- just test -->
                            <!-- <span class="all-style" v-if="radioGroup == 7">{{ $t('message.acleda') }}</span> -->
                            <!-- <span class="all-style" v-if="radioGroup == 0">{{ $t('message.ABAPay') }}</span> -->
                            <!-- </div>
                        </div> -->
                            <div class="container-total">
                                <div class="summary-grid">
                                    <div class="summary-row">
                                        <div class="summary-label">{{ $t('message.Paymenttype') }}</div>
                                        <div class="summary-value" style="font-weight: 600;">
                                            <span v-if="radioGroup == 5">{{ $t('message.abakhqr') }}</span>
                                            <span v-if="radioGroup == 4">{{ $t('message.wingBank') }}</span>
                                            <span v-if="radioGroup == 8">{{ $t('message.acleda') }}</span>
                                            <span v-if="radioGroup == 9">{{ $t('message.KHQR') }}</span>
                                            <span v-if="radioGroup == 6">{{ $t('message.creditDebitCard') }}</span>

                                        </div>
                                    </div>

                                    <div class="summary-price" style="line-height: 2.5;">
                                        <div class="summary-row">
                                            <div class="summary-label">{{ $t('message.grandTotal') }}</div>
                                            <div class="summary-value">${{ getSubTotal() }}</div>
                                        </div>

                                        <div class="summary-row" v-if="Number(getDiscount()) > 0" style="">
                                            <div class="summary-label">{{
                                                $t('message.discount') }}</div>
                                            <div class="summary-value">${{ getDiscount() }}</div>
                                        </div>

                                        <div v-if="getSelectedPaymentDiscountAmount() === 0 && getSelectedPaymentServiceFeeAmount() === 0"
                                            style="border-bottom: 1px solid #C6C6C6;"></div>

                                        <div class="summary-row" style="border-bottom: 1px solid #C6C6C6;"
                                            v-if="getSelectedPaymentDiscountAmount() > 0">
                                            <div class="summary-label">{{ $t('message.discount') }} ({{
                                                getSelectedPaymentDisplayName() }})</div>
                                            <div class="summary-value">${{
                                                formatPrice(getSelectedPaymentDiscountAmount()) }}</div>
                                        </div>

                                        <div class="summary-row" style="border-top: 1px solid #C6C6C6;"
                                            v-if="getSelectedPaymentServiceFeeAmount() > 0">
                                            <div class="summary-label">{{ $t('message.serviceFee') }} ({{
                                                formatPaymentPercent(getSelectedPaymentServiceFeePercent()) }}%)</div>
                                            <div class="summary-value">${{
                                                formatPrice(getSelectedPaymentServiceFeeAmount()) }}</div>
                                        </div>


                                        <!-- <div class="summary-row" v-if="getSelectedPaymentDiscountAmount() <= 0 && getSelectedPaymentServiceFeeAmount() <= 0" style="padding-top: 12px;">
                                            <div class="summary-label">{{ $t('message.serviceFee') }} (0%)</div>
                                            <div class="summary-value">$0.00</div>
                                        </div> -->
                                        <div class="summary-row">
                                            <div class="" style="color: #20292F;  font-weight: 600; font-size: 14px;">{{
                                                $t('message.total') }}</div>
                                            <div class="summary-value" style="color: #20292F; font-weight: 600;"> {{ '$'
                                                + formatPrice(getTotal()) }} </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div style="padding-top: 20px;">
                                <span>{{ $t('message.desTermCoditionPrivacyPolicy') }} <a href="/term-condition"
                                        target="_blank" style="color: #2296F3;">{{ $t('message.termCondition') }}</a> {{
                                            $t('message.desTermCoditionPrivacyPolicyAnd') }} <a href="/privacy-policy"
                                        target="_blank" style="color: #2296F3;">{{ $t('message.privacyPolicy')
                                        }}</a></span>
                            </div> -->
                            <div class="button-pay-first">
                                <button :disabled="disable" class="book-pay-now" @click="getProcessPayment">
                                    <p style="margin-bottom: 0%;">{{ $t(titleButton) }}</p> <img
                                        src="@/assets/icon_bars/icon_right.svg" alt="">
                                </button>
                            </div>
                        </div>

                        <transition name="fade">
                            <div v-if="showPaymentFrame" class="payment-frame">
                                <div class="set-wi-he">
                                    <i class="fa-solid fa-xmark" @click="showPaymentFrameFal"
                                        style="cursor: pointer;position: absolute;top: 31px;right: 4%;font-size: 20px;"></i>
                                    <iframe style="border-radius: 20px;" :src="paymentUrl" frameborder="0" width="100%"
                                        height="100%"></iframe>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <!-- small screen -->
        <div class="small-screen">
            <div class="containers">
                <div class="summary-left" style="border-top: 1px solid #C6C6C6;">
                    <div v-show="!viewTrip" class="view-detail-payment" @click="viewTrip = !viewTrip"
                        style="border-bottom: 1px solid #C6C6C6; cursor: pointer; padding: 1rem 0rem 1rem 0rem; color: #2296F3; font-weight: 500; font-size: 14px;">
                        <span>{{ $t('message.viewTripDetails') }}</span>

                    </div>
                    <div v-show="viewTrip" style="padding: 1rem 0rem 1rem 0rem;">
                        <div class="trip-sum">{{ $t('message.tripsummary') }}</div>
                        <div class="all-info" style="font-weight: 600;">{{ $t('message.billingDetail') }}</div>
                        <div class="row" style="flex-wrap: nowrap; margin: 0;">
                            <div class="col-lg-3 col-md-3 col-sm-3"
                                style="display: flex; flex-direction: column; width: 30%; padding: 0;">
                                <span class="all-info">{{ $t('message.orderId') }}</span>
                                <span v-if="getEmail()" class="all-info">{{ $t('message.email') }}</span>
                                <span v-if="tleFalse" class="all-info">{{ $t('message.tel') }}</span>
                            </div>
                            <div style="display: flex; flex-direction: column; width: 70%; padding: 0;"
                                class="col-lg-9 col-md-9 col-sm-9">
                                <span class="all-info"> : {{ transactionId }}</span>
                                <span v-if="getEmail()" class="all-info"> : {{ getEmail() }}</span>
                                <span v-if="tleFalse" class="all-info"> : {{ getPhone() }}</span>
                            </div>
                        </div>
                        <div>
                            <div class="all-info" style="border-top: 1px solid #C6C6C6;"></div>
                        </div>
                        <div class="all-info">{{ getDestinationFrom() }} - {{ getdestinationToName() }}
                        </div>
                        <div class="row" style="flex-wrap: nowrap; margin: 0;">
                            <div class="col-lg-3 col-md-3 col-sm-3"
                                style="display: flex; flex-direction: column; width: 30%; padding: 0;">
                                <span class="all-info">{{ $t('message.vehicleType') }}</span>
                                <span class="all-info">{{ $t('message.departure') }}</span>
                            </div>
                            <div class="col-lg-9 col-md-9 col-sm-9"
                                style="display: flex; flex-direction: column; width: 70%; padding: 0;">
                                <span class="all-info"> : {{ getTransportationType() }} </span>
                                <span class="all-info"> : {{ getDateFrom() }}, at {{
                                    convertTimes(getDeparture()) }}</span>
                            </div>
                        </div>
                        <div v-for="(seat, index) in getSeatNum()" :key="index" class="seat-info"
                            :class="{ 'with-border': index !== 0 }" style="padding-bottom: 20px;">
                            <div class="row" style="margin: 0; flex-wrap: nowrap;">
                                <div class="col-lg-3 col-md-3 col-sm-3"
                                    style="display: flex; flex-direction: column; padding: 0; width: 30%;">
                                    <span class="all-info">{{ getseatType() == 2 ? $t('message.bedno') :
                                        $t('message.seatno') }}</span>

                                    <span class="all-info">{{ $t('message.gender') }}</span>
                                    <span class="all-info">{{ $t('message.nationality') }}</span>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9"
                                    style="display: flex; flex-direction: column; width: 70%; padding: 0;">
                                    <span class="all-info">: {{ getSeatLabel()[index] }}</span>

                                    <span class="all-info">: {{ getGender()[index] }}</span>
                                    <span class="all-info">: {{ getNationality()[index] }}</span>
                                </div>
                            </div>
                        </div>

                        <div v-if="returnTrip">
                            <div class="all-info"><img style="width: 100%;" src="@/assets/Line112.png" alt=""></div>
                            <div class="all-info">{{ getdestinationToName() }} - {{ getDestinationFrom() }}
                            </div>

                            <div class="row" style="margin: 0%; flex-wrap: nowrap;">
                                <div class="col-lg-3 col-md-3 col-sm-3"
                                    style="display: flex; flex-direction: column;  padding: 0%; width: 30%;">
                                    <span class="all-info">{{ $t('message.vehicleType') }} </span>
                                    <span class="all-info">{{ $t('message.departure') }} </span>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9"
                                    style="display: flex; flex-direction: column; padding: 0%; width: 70%;">
                                    <span class="all-info">: {{ getTransportationTypeBack() }}</span>
                                    <span class="all-info">: {{ getDateTo() }}, at {{
                                        convertTimes(getDepartureBack()) }}</span>
                                </div>
                            </div>
                            <!-- <div v-if="getSeatNum().length > 0" class="all-info" style="border: 0.4px dotted #C6C6C6;">
                            </div> -->
                            <div v-for="(seat, index) in getSeatNumBack()" :key="index" class="seat-info"
                                :class="{ 'with-border': index !== 0 }" style="padding-bottom: 20px;">
                                <div class="row" style="margin: 0%; flex-wrap: nowrap;">
                                    <div class="col-lg-3 col-md-3 col-sm-3"
                                        style="display: flex; flex-direction: column; padding: 0%; width: 30%;">

                                        <span class="all-info">{{ getseatTypeBack() == 2 ? $t('message.bedno') :
                                            $t('message.seatno') }}</span>
                                        <span class="all-info">{{ $t('message.gender') }}</span>
                                        <span class="all-info">{{ $t('message.nationality') }}</span>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-9"
                                        style="display: flex; flex-direction: column; padding: 0%; width: 70%;">

                                        <span class="all-info">: {{ getSeatLabelBack()[index] }}</span>
                                        <span class="all-info">: {{ getGenderBack()[index] }}</span>
                                        <span class="all-info">: {{ getNationalityBack()[index] }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="small-payment">
                <div class="summary-grid1" v-show="viewTrip">
                    <div class="containers" style="padding: 1rem 0rem 1rem 0rem;">
                        <div class="summary-row">
                            <!-- <div class="summary-label">{{ $t('message.paymentMethod') }}:</div> -->
                            <div class="" style="font-weight: 600; text-align: start;">
                                <span v-if="radioGroup == 5">{{ $t('message.abakhqr') }}</span>
                                <span v-if="radioGroup == 4">{{ $t('message.wingBank') }}</span>
                                <span v-if="radioGroup == 8">{{ $t('message.acleda') }}</span>
                                <span v-if="radioGroup == 9">{{ $t('message.KHQR') }}</span>
                                <span v-if="radioGroup == 6">{{ $t('message.creditDebitCard') }}</span>

                            </div>
                        </div>

                        <div class="summary-price" style="line-height: 2.5;">
                            <div class="summary-row">
                                <div class="summary-label">{{ $t('message.grandTotal') }}</div>
                                <div class="summary-value">${{ getSubTotal() }}</div>
                            </div>

                            <div class="summary-row" v-if="Number(getDiscount()) > 0">
                                <div class="summary-label">{{ $t('message.discount') }}</div>
                                <div class="summary-value" style="">${{ getDiscount() }}</div>
                            </div>

                            <div class="summary-row" v-if="getSelectedPaymentDiscountAmount() > 0">
                                <div class="summary-label">{{ $t('message.discount') }} ({{
                                    getSelectedPaymentDisplayName() }})</div>
                                <div class="summary-value">${{ formatPrice(getSelectedPaymentDiscountAmount()) }}</div>
                            </div>

                            <div style="border-bottom: 1px solid #C6C6C6; margin-bottom: 20px; margin-top: 20px;"></div>

                            <div class="summary-row" v-if="getSelectedPaymentServiceFeeAmount() > 0">
                                <div class="summary-label">{{ $t('message.serviceFee') }} ({{
                                    formatPaymentPercent(getSelectedPaymentServiceFeePercent()) }}%)</div>
                                <div class="summary-value">${{ formatPrice(getSelectedPaymentServiceFeeAmount()) }}
                                </div>
                            </div>

                            <div class="summary-row"
                                v-if="getSelectedPaymentDiscountAmount() <= 0 && getSelectedPaymentServiceFeeAmount() <= 0">
                                <div class="summary-label">{{ $t('message.serviceFee') }} (0%)</div>
                                <div class="summary-value">$0.00</div>
                            </div>
                            <div class="summary-row">
                                <div class="" style="color: #20292F;  font-weight: 600; font-size: 14px;">{{
                                    $t('message.total') }}:</div>
                                <div class="summary-value" style="color: #20292F;font-weight: 600; "> {{ '$' +
                                    formatPrice(getTotal()) }} </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="containers">
                <div class="button-pay">
                    <div v-show="viewTrip" class="view-detail-payment" @click="viewTrip = !viewTrip"
                        style="border-bottom: 1px solid #C6C6C6; cursor: pointer; padding: 1rem 0rem 1rem 0rem; color: #2296F3; font-weight: 500; font-size: 14px;">
                        <span>{{ $t('message.viewTripLess') }}</span>
                    </div>
                    <div class=""
                        style="padding: 1rem 0rem 0rem 0rem; display: flex; justify-content: space-between; align-items: center;"
                        v-show="!viewTrip">
                        <div class="" style="color: #20292F;  font-weight: 600; font-size: 14px;">{{ $t('message.total')
                            }}:</div>
                        <div class="summary-value" style="color: #20292F; font-weight: 600;"> {{ '$' +
                            formatPrice(getTotal()) }} </div>
                    </div>
                    <button :disabled="disable" class="book-pay-now" @click="getProcessPayment">
                        <p style="margin-bottom: 0%; ">{{ $t(titleButton) }}</p> <img
                            src="@/assets/icon_bars/icon_right.svg" alt="">
                    </button>
                </div>

            </div>
        </div>

        <!-- ACLEDA Sub-Payment Method Dialog -->
        <v-dialog v-model="showAcledaDialog" max-width="520" persistent>
            <div class="acleda-dialog">
                <!-- Header -->
                <div class="acleda-dialog-header">
                    <div class="acleda-dialog-title">
                        <!-- <img src="@/assets/ACLEDA_PAY.svg" alt="ACLEDA" class="acleda-dialog-logo"> -->
                        <span>{{ $t('message.paymentMethod') }}</span>
                    </div>
                    <button class="acleda-dialog-close" @click="showAcledaDialog = false">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <!-- Route label -->
                <!-- <div class="acleda-dialog-route">
                    {{ getDestinationFrom() }} - {{ getdestinationToName() }}
                </div> -->

                <!-- Sub-method options -->
                <div class="acleda-dialog-body">
                    <!-- KHQR -->
                    <div class="acleda-dialog-method-card" @click="selectAcledaAndPay(9)">
                        <div class="acleda-dialog-img-card">
                            <img src="@/assets/payment/QR.png" alt="KHQR">
                        </div>
                        <div class="acleda-dialog-text">
                            <div class="acleda-dialog-card-title">KHQR Payment</div>
                            <div class="acleda-dialog-card-desc">Scan to pay with Bakong app or any bank apps</div>
                        </div>
                        <div class="acleda-dialog-arrow">
                            <i class="fa-solid fa-chevron-right"></i>
                        </div>
                    </div>

                    <!-- Credit / Debit Card -->
                    <div class="acleda-dialog-method-card" @click="selectAcledaAndPay(8)">
                        <div class="acleda-dialog-img-card">
                            <img src="@/assets/payment/Credit Card.png" alt="Card">
                        </div>
                        <div class="acleda-dialog-text">
                            <div class="acleda-dialog-card-title">{{ $t('message.creditDebitCard') }}</div>
                            <div class="acleda-dialog-card-desc">
                                <img src="@/assets/payment/New Project.png" alt="cards" style="height: 100%;">
                            </div>
                        </div>
                        <div class="acleda-dialog-arrow">
                            <i class="fa-solid fa-chevron-right"></i>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <!-- <div class="acleda-dialog-footer">
                    <button class="acleda-cancel-btn" @click="showAcledaDialog = false">Cancel</button>
                    <button
                        class="acleda-confirm-btn"
                        :disabled="!acledaSubMethod || acledaPayLoading"
                        @click="confirmAcledaPayment"
                    >
                        <span v-if="acledaPayLoading">Loading...</span>
                        <span v-else>Require Payment</span>
                        <img v-if="!acledaPayLoading" src="@/assets/icon_bars/icon_right.svg" alt="" style="margin-left: 8px;">
                    </button>
                </div> -->
            </div>
        </v-dialog>
    </div>

</template>
<script src="https://checkout.payway.com.kh/plugins/checkout2-0.js"></script>// production
<!-- <script src="https://checkout.payway.com.kh/plugins/checkout2-0-dev.js"></script> // qa -->
<script>
import axios from 'axios';
import qs from 'qs';
import { loadScript } from "vue-plugin-load-script";
export default {
    data() {
        return {
            loading: false,
            tleFalse: false,
            phone: "",
            info: [],
            radioGroup: 5,
            isActive: false,
            returnTrip: false,
            showDiscount: false,
            showDiscountback: false,
            discount: 5,
            showPaymentFrame: false,
            titleButton:"message.payNow",
            paymentUrl: "",
            urlABA: 'https://checkout.payway.com.kh/plugins/checkout2-0.js', // production
            // urlABA: 'https://checkout.payway.com.kh/plugins/checkout2-0-dev.js', // qa
            disable:false,
            transactionId: this.$route.query.transactionId,
            paymentFormPost: "",
            seconds: 360,
            timesetTransa: '',

            disPercent: localStorage.getItem('disPercent'),
            disPercentBack: localStorage.getItem('disPercentBack'),
            info1: localStorage.getItem("discount"),
            isCancelingBooking: false, // Add this flag
            viewTrip: false,
            historyBlocked: false,
            popstateHandler: null,
            // ACLEDA sub-payment dialog
            showAcledaDialog: false,
            acledaSubMethod: '', // default: KHQR=8, Credit/Debit Card=9
            acledaPayLoading: false,
        }
        
    },
    methods: {

      getseatType(){
            const seatType = localStorage.getItem('seatType');
            return seatType ? seatType : '';
        },
        getseatTypeBack(){
            const seatTypeBack = localStorage.getItem('seatTypeBack');
            return seatTypeBack ? seatTypeBack : '';
        },
        convertTimes(time) {
            if (!time || typeof time !== 'string' || !time.includes(':')) {
                return time || '';
            }
            const [hours, minutes] = time.split(':');
            return `${hours}:${minutes}`;
        },
        startTimer() {
            this.timer = setInterval(() => {
                if (this.seconds > 1) {
                    this.seconds--;
                    this.timesetTransa =  this.formatTime(this.seconds);
                } else {
                    clearInterval(this.timer);
                // Optionally, you can perform an action when the countdown reaches zero
                }
            }, 1000);
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${this.pad(minutes)}:${this.pad(remainingSeconds)}`;
        },
        pad(value) {
            return value < 10 ? `0${value}` : value;
        },
        getCheck() {
            if(localStorage.getItem('dateTo') != null){
                this.returnTrip = true;
            }else{
                this.returnTrip = false;
            }
        },
        getTotalLuckeydraw() { return localStorage.getItem('totalluckydraw'); },
        
        getPaymentMethods() {
            const paymentMethods = localStorage.getItem('paymentMethods');
            if (!paymentMethods) {
                return [];
            }

            try {
                const parsed = JSON.parse(paymentMethods);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                return [];
            }
        },

        getSelectedPaymentMethod() {
            const methods = this.getPaymentMethods();
            const selectedId = Number(this.radioGroup);
            return methods.find(item => Number(item.id) === selectedId) || null;
        },

        getSelectedPaymentDisplayName() {
            if (Number(this.radioGroup) === 4) {
                return this.$t('Wing');
            }
            if (Number(this.radioGroup) === 5) {
                return this.$t('message.abakhqr');
            }
            if (Number(this.radioGroup) === 6) {
                return this.$t('message.creditDebitCard');
            }
            if (Number(this.radioGroup) === 8) {
                return this.$t('message.acleda');
            }

            const paymentMethod = this.getSelectedPaymentMethod();
            return paymentMethod && paymentMethod.name ? paymentMethod.name : '-';
        },

        getSelectedPaymentDiscountAmount() {
            const paymentMethod = this.getSelectedPaymentMethod();
            if (!paymentMethod) {
                return 0;
            }
            const amount = parseFloat(paymentMethod.discountAmount || '0');
            return Number.isFinite(amount) ? amount : 0;
        },

        getSelectedPaymentServiceFeeAmount() {
            const paymentMethod = this.getSelectedPaymentMethod();
            if (!paymentMethod) {
                return 0;
            }
            const amount = parseFloat(paymentMethod.serviceFeeAmount || '0');
            return Number.isFinite(amount) ? amount : 0;
        },

        getSelectedPaymentServiceFeePercent() {
            const paymentMethod = this.getSelectedPaymentMethod();
            if (!paymentMethod) {
                return 0;
            }
            const percent = parseFloat(paymentMethod.serviceFeePercent || 0);
            return Number.isFinite(percent) ? percent : 0;
        },

        formatPaymentPercent(value) {
            const numeric = Number(value) || 0;
            return Number.isInteger(numeric) ? numeric : numeric.toFixed(2);
        },
        
        getDestinationFrom() {
            if( localStorage.getItem('lang') == 'ch'){
                return localStorage.getItem('departureFromNameCn');
            }else if( localStorage.getItem('lang') == 'kh'){
                return localStorage.getItem('departureFromNameKh');
            }else{
                return localStorage.getItem('departureFromName');
            }
        },
        getdestinationToName() {
            if( localStorage.getItem('lang') == 'ch'){
                return localStorage.getItem('destinationToNameCn');
            }else if( localStorage.getItem('lang') == 'kh'){
                return localStorage.getItem('destinationToNameKh');
            }else{
                return localStorage.getItem('destinationToName');
            }
        },
        getDateFrom() { return localStorage.getItem('dateFrom');},
        getDeparture() { return localStorage.getItem('departure');},
        getDateTo() { return localStorage.getItem('dateTo');},
        getDepartureBack() { return localStorage.getItem('departureback');},    
        hasPriceValue(value) {
            if (value === null || value === undefined) {
                return false;
            }
            const normalized = String(value).trim();
            return normalized !== '' && normalized !== '0';
        },
        grandTotal() {
            return parseFloat(localStorage.getItem('resultTotal') || '0');
        },
        disConut() {
            const orderPaymentListsDiscount = this.getOrderPaymentListsDiscountAmount();
            if (orderPaymentListsDiscount !== null) {
                return orderPaymentListsDiscount;
            }

            const discountValue = parseFloat(localStorage.getItem('discount') || '0');
            const seatCount = Number(this.getSeatNum()) || 0;
            return discountValue * seatCount;
        },
        
       
        totalDiscosunt() {
            const hasOutboundOriginalPrice = this.hasPriceValue(localStorage.getItem('priceOriginal'));
            const hasReturnOriginalPrice = this.hasPriceValue(localStorage.getItem('priceOriginalback'));

            if (!hasReturnOriginalPrice && !hasOutboundOriginalPrice) {
                return parseFloat(this.disConut()) + parseFloat(this.disConutBack());
            }

            if (hasReturnOriginalPrice && !hasOutboundOriginalPrice) {
                return this.disConut();
            }

            if (!hasReturnOriginalPrice && hasOutboundOriginalPrice) {
                return this.disConutBack();
            }

            return 0;
        },
        getFullName() { return localStorage.getItem('fullname') },
        getEmail() { return localStorage.getItem('email') },
        getPhone() { 
            if(localStorage.getItem("phone") != null && localStorage.getItem("phone") != "") {
                this.tleFalse = true;
                this.phone = localStorage.getItem('phone');
                return this.phone;
            }else{
                this.tleFalse = false;
                return "";
            }
            
        },
        getOrderPaymentListsDiscountAmount() {
            const orderPaymentListsRaw = localStorage.getItem('orderPaymentLists');

            if (!orderPaymentListsRaw) {
                return null;
            }

            try {
                const orderPaymentLists = JSON.parse(orderPaymentListsRaw);
                if (Array.isArray(orderPaymentLists) && orderPaymentLists.length > 0) {
                    const firstItem = orderPaymentLists[0];
                    const rawDiscount = firstItem && (firstItem.discount ?? firstItem.discountAmount ?? 0);
                    const discount = parseFloat(rawDiscount || '0');
                    return Number.isFinite(discount) ? discount : 0;
                }
            } catch (error) {
                console.log('Failed to parse orderPaymentLists discount:', error);
            }

            return null;
        },

        getDiscount() {
            const orderPaymentListsDiscount = this.getOrderPaymentListsDiscountAmount();
            if (orderPaymentListsDiscount !== null) {
                return orderPaymentListsDiscount.toFixed(2);
            }

            const discount = localStorage.getItem("discount");
            if (!discount) {
                return "0.00";
            }
            const parsedDiscount = parseFloat(discount);
            return parsedDiscount.toFixed(2);
        },
        getDiscountPercent() {
        const discountPercent = localStorage.getItem("discountPercent");
        return discountPercent ? parseInt(discountPercent) : 0;
    },
    
    getTotal() {
        const total = parseFloat(localStorage.getItem('total') || '');
        let finalTotal = !Number.isNaN(total) && total > 0 ? total : 0;

        // Fallback for older flow where "total" is not yet stored
        if (finalTotal <= 0) {
        const priceOriginal = localStorage.getItem('priceOriginal');
        const resultTotal = parseFloat(localStorage.getItem('resultTotal') || '0');
        const luckyDraw = parseFloat(localStorage.getItem('totalluckydraw') || '0');
        finalTotal = resultTotal + luckyDraw;

        if (!this.hasPriceValue(priceOriginal)) {
            this.showDiscount = true;
            finalTotal = resultTotal - this.disConut() + luckyDraw;
        } else {
            this.showDiscount = false;
        }
        }

        // Apply payment method level amounts from booking response in localStorage
        const paymentDiscount = this.getSelectedPaymentDiscountAmount();
        const paymentServiceFee = this.getSelectedPaymentServiceFeeAmount();
        return Math.max(0, finalTotal - paymentDiscount + paymentServiceFee);
    },
    
    getSubTotal() {
        const orderPaymentListsRaw = localStorage.getItem('orderPaymentLists');

        if (orderPaymentListsRaw) {
            try {
                const orderPaymentLists = JSON.parse(orderPaymentListsRaw);
                if (Array.isArray(orderPaymentLists) && orderPaymentLists.length > 0) {
                    const firstItem = orderPaymentLists[0];
                    const grandTotal = parseFloat(firstItem && firstItem.grandTotal ? firstItem.grandTotal : 0);
                    
                    return (Number.isFinite(grandTotal) ? grandTotal : 0).toFixed(2);
                }
            } catch (error) {
                console.log('Failed to parse orderPaymentLists:', error);
            }
        }

        const legacySubTotal = localStorage.getItem('subTotal');
        return legacySubTotal ? parseFloat(legacySubTotal).toFixed(2) : '0.00';
    },


        getSeatNum() {
            const seatNum = localStorage.getItem('seat');
            if (!seatNum) {
                this.seatNum = 0;
                return 0;
            }
            const seatNumArray = seatNum.split(',').filter(item => item && item.trim() !== '');
            this.seatNum = seatNumArray.length;
            return this.seatNum;
        },
        getSeatLabel() {
            const size = localStorage.getItem('seatlabel');
            if (!size) {
                return [];
            }
            return size.split(',').filter(seat => seat && seat.trim() !== '');
        },
        getGender() {
            if(localStorage.getItem('gender') != '' && localStorage.getItem('gender') != null) {
                let gender = localStorage.getItem('gender');
                let genderArray;
                try {
                    // Try to parse as JSON array first
                    genderArray = JSON.parse(gender);
                } catch (e) {
                    // If not JSON, split by comma
                    genderArray = gender.split(",");
                }
                // Convert numeric values (1=Male, 2=Female) to text
                let genderText = genderArray.map(value => {
                    const trimmed = String(value).trim();
                    if (trimmed === '1') return this.$t('message.male');
                    if (trimmed === '2') return this.$t('message.Female');
                    return trimmed;
                });
                return this.gender = genderText;
            }
            return [];
        },
        getGenderBack() {
            if(localStorage.getItem('genderback') != '' && localStorage.getItem('genderback') != null) {
                let genderback = localStorage.getItem('genderback');
                let genderArray;
                try {
                    // Try to parse as JSON array first
                    genderArray = JSON.parse(genderback);
                } catch (e) {
                    // If not JSON, split by comma
                    genderArray = genderback.split(",");
                }
                // Convert numeric values (1=Male, 2=Female) to text
                let genderText = genderArray.map(value => {
                    const trimmed = String(value).trim();
                    if (trimmed === '1') return this.$t('message.male');
                    if (trimmed === '2') return this.$t('message.Female');
                    return trimmed;
                });
                return this.genderback = genderText;
            }
            return [];
        },

        getSeatNumBack() {
            const seatNumBack = localStorage.getItem('seatback');
            if (!seatNumBack) {
                this.seatNumBack = 0;
                return 0;
            }
            const seatNumBackArray = seatNumBack.split(',').filter(item => item && item.trim() !== '');
            this.seatNumBack = seatNumBackArray.length;
            return this.seatNumBack;
        },
        getNationality() {
            const nationality = localStorage.getItem('nationalitynamelist');
            if (!nationality) {
                this.nationality = [];
                return [];
            }
            const nationalityArray = nationality.split(',').filter(item => item && item.trim() !== '');
            this.nationality = nationalityArray;
            return this.nationality;
        },
        getNationalityBack() {
            const nationalityBack = localStorage.getItem('nationalitynamelistback');
            if (!nationalityBack) {
                this.nationalityBack = [];
                return [];
            }
            const nationalityBackArray = nationalityBack.split(',').filter(item => item && item.trim() !== '');
            this.nationalityBack = nationalityBackArray;
            return this.nationalityBack;
        },
        getSeatLabelBack() {
            const size = localStorage.getItem('seatlabelback');
            if (!size) {
                return [];
            }
            return size.split(',').filter(seat => seat && seat.trim() !== '');
        },
        getTransportationType() {
            const transportationType = localStorage.getItem('transportationType');
            if (!transportationType) {
                this.transportationType = '';
                return '';
            }
            this.transportationType = transportationType;
            return this.transportationType;
        },
        getTransportationTypeBack() {
            const transportationTypeBack = localStorage.getItem('transportationTypeBack');
            if (!transportationTypeBack) {
                this.transportationTypeBack = '';
                return '';
            }
            this.transportationTypeBack = transportationTypeBack;
            return this.transportationTypeBack;
        },

        // Return Trip (one way)
        grandTotalRe() {
            const resultTotal = parseFloat(localStorage.getItem('resultTotal') || '0');
            const resultTotalBack = parseFloat(localStorage.getItem('resultTotalBack') || '0');
            return resultTotal + resultTotalBack;
        },
        disConutBack() {
            const discountValue = parseFloat(localStorage.getItem('discountBack') || '0');
            const seatCount = Number(this.getSeatNumBack()) || 0;
            return discountValue * seatCount;
        },
        totalRetureTirp() {
            const priceOriginal = localStorage.getItem('priceOriginal');
            const priceOriginalBack = localStorage.getItem('priceOriginalback');
            const resultTotal = parseFloat(localStorage.getItem('resultTotal') || '0');
            const resultTotalBack = parseFloat(localStorage.getItem('resultTotalBack') || '0');
            const luckyDraw = parseFloat(localStorage.getItem('totalluckydraw') || '0');

            if (!this.hasPriceValue(priceOriginalBack) && !this.hasPriceValue(priceOriginal)) {
                this.showDiscountback = true;
                return resultTotal + resultTotalBack - this.totalDiscosunt() + luckyDraw;
            }
            if (this.hasPriceValue(priceOriginalBack) && !this.hasPriceValue(priceOriginal)) {
                this.showDiscountback = true;
                return resultTotal + resultTotalBack - this.disConut() + luckyDraw;
            }
            if (!this.hasPriceValue(priceOriginalBack) && this.hasPriceValue(priceOriginal)) {
                this.showDiscountback = true;
                return resultTotal + resultTotalBack - this.disConutBack() + luckyDraw;
            }

            this.showDiscountback = false;
            return resultTotal + resultTotalBack;
        },
        // cut (,)
        formatPrice(value) { let val = (value/1).toFixed(2); return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");},
        showPaymentFrameFal() {
            if (window.confirm(this.$t('message.areyousureyouwanttoclose'))) {
                this.showPaymentFrame = false;
                this.$router.go();
            } else {
                // User clicked Cancel
                // Perform any other action or do nothing
            }
        },
        

        async getProcessPayment() {
            if(this.radioGroup == 0) {
                alert("Please select payment type before click button pay now.");
            } else if (this.radioGroup == 8) {
                // ACLEDA: show sub-payment method popup first
                this.acledaSubMethod = ''; // default KHQR
                this.showAcledaDialog = true;
            } else {
                this.titleButton="Loading";
                this.disable = true;
                const data = { 
                    'code': this.$route.query.transactionId,
                    'paymentMethodId': parseInt(this.radioGroup)
                }
                
                const url = this.$url + `booking/processPayment`;

                let config = {
                    method: "POST",
                    headers: this.$header,
                    data: qs.stringify(data),
                    url
                };
                axios(config).then((response) => {
                    if (response.status == 200) {
                        if(response.data.header.result == true && response.data.header.statusCode == 200) {  
                            this.titleButton="message.payNow";
                            this.disable = false;
                            this.info = response.data.body;
                              if(this.info.status == 1){ // True
                                
                                if(this.radioGroup == 4){
                                    if(response.data.body.request != "") {
                                        window.location.href = response.data.body.request;
                                    }else{
                                        alert("Invaild Payment Method");
                                    }
                                } else {
                                    this.paymentFormPost = response.data.body.request;
                                    loadScript(this.urlABA)
                                    .then(() => {
                                        AbaPayway.checkout();
                                    })
                                    .catch(() => {
                                        console.log("error process payment aba");
                                    });
                                }
                            } else { // Session Expired
                                alert("Session Expired");
                                this.$router.push("/");
                            }
                        } else { // Error
                            alert("Sorry, the payment process failed. Please try it again.");
                            // this.$router.push("/");
                        }
                    }else {
                        console.log('Not Status 200');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        selectAcledaAndPay(subMethod) {
            this.acledaSubMethod = subMethod;
            this.confirmAcledaPayment();
        },

        async confirmAcledaPayment() {
            if (!this.acledaSubMethod) return;
            this.acledaPayLoading = true;
            const data = { 
                'code': this.$route.query.transactionId,
                'paymentMethodId': parseInt(this.acledaSubMethod)
            };
            const url = this.$url + `booking/processPayment`;
            let config = {
                method: "POST",
                headers: this.$header,
                data: qs.stringify(data),
                url
            };
            axios(config).then((response) => {
                this.acledaPayLoading = false;
                if (response.status == 200) {
                    if (response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.info = response.data.body;
                        if (this.info.status == 1) { // True
                            this.showAcledaDialog = false;
                            if (this.acledaSubMethod == 8) {
                                // KHQR: redirect to external ACLEDA KHQR page
                                if (response.data.body.request != "") {
                                    window.location.href = response.data.body.request;
                                } else {
                                    alert("Invalid Payment Method");
                                }
                            } else if (this.acledaSubMethod == 9) {
                              if (response.data.body.request != "") {
                                    window.location.href = response.data.body.request;
                                } else {
                                    alert("Invalid Payment Method");
                                }
                            }
                        } else { // Session Expired
                            alert("Session Expired");
                            this.$router.push("/");
                        }
                    } else { // Error
                        alert("Sorry, the payment process failed. Please try it again.");
                    }
                } else {
                    console.log('Not Status 200');
                }
            }).catch((error) => {
                this.acledaPayLoading = false;
                console.log(error);
            });
        }, 
        async paymentComplete() {
            const discount = localStorage.getItem("discount");
            const data = {
                'transactionId': this.$route.query.transactionId
            }
            
            const url = this.$url + `booking/complete`;
            let config = {
                method: "POST",
                headers: this.$header,
                data: qs.stringify(data),
                url               
            };
            this.clearStorage();
            this.loading  = true;
            axios(config).then((response) => {
                if (response.status == 200) {
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {  
                        this.info = response.data.body;
                        if(this.info.status == 1){ // Complete
                            // Unblock navigation before redirecting
                            this.unblockBrowserBack();
                            // this.showPaymentFrame = false;
                            this.$router.push({
                                path: "/payment-success",
                                query: {
                                    transactionId: this.$route.query.transactionId
                                }
                            });
                        } else { // not complete
                            this.loading = false;
                            this.showPaymentFrame = false;
                            alert("Payment Not Success");
                        }
                    } else { // Error
                        this.loading = false;
                        this.showPaymentFrame = false;
                        if (window.confirm("Please try it again.")) {
                            this.cancelBooking();
                        }else{
                            // User clicked Cancel
                            // Perform any other action or do nothing
                        }
                    }
                }
            }).catch((error) => {console.log(error);});
        },
        async cancelBooking(options = {}) {
            const {
                skipConfirm = false,
                skipNavigation = false,
                skipHistoryReset = false,
            } = options;

            if (!skipConfirm) {
                const confirmed = window.confirm(this.$t('message.doyouwanttocancelbooking'));
                if (!confirmed) {
                    return false;
                }
            }

            this.isCancelingBooking = true;
            const cancelled = await this.sendCancelBookingRequest();

            if (!cancelled) {
                this.isCancelingBooking = false;
                return false;
            }

            if (!skipHistoryReset) {
                window.history.replaceState(null, '', '/');
            }

            if (!skipNavigation) {
                this.$router.replace("/");
            }

            return true;
        },

        async sendCancelBookingRequest() {
            const data = {
                'transactionId': this.$route.query.transactionId,
            };
            const url = this.$url + `booking/cancel`;
            const config = {
                method: "POST",
                headers: this.$header,
                data: qs.stringify(data),
                url
            };

            this.loading = true;
            try {
                const response = await axios(config);
                if (response.status === 200) {
                    localStorage.removeItem('handleBrowser');
                    this.clearStorage();
                    return true;
                }
                return false;
            } catch (error) {
                console.log(error);
                return false;
            } finally {
                this.loading = false;
            }
        },
        clearStorage() {
            localStorage.removeItem("departureFromName");
            localStorage.removeItem("departureFromId");
            localStorage.removeItem("destinationToName");
            localStorage.removeItem("destinationToId");
            localStorage.removeItem("dateFrom");
            localStorage.removeItem("dateTo");

            localStorage.removeItem("price");
            localStorage.removeItem("departure");
            localStorage.removeItem("arrival");
            localStorage.removeItem("duration");
            localStorage.removeItem("journeyid");
            localStorage.removeItem("priceOriginal");

            localStorage.removeItem("priceback");
            localStorage.removeItem("departureback");
            localStorage.removeItem("durationback");
            localStorage.removeItem("arrivalback");
            localStorage.removeItem("journeyidback");
            localStorage.removeItem("priceOriginalback");

            localStorage.removeItem("resultTotal");
            localStorage.removeItem("resultTotalBack");
            localStorage.removeItem("totalluckydraw");
            localStorage.removeItem("promoCode");

            localStorage.removeItem("seat");
            localStorage.removeItem("seatlabel");
            localStorage.removeItem("seatback");
            localStorage.removeItem("seatlabelback");

            localStorage.removeItem("trips");
            localStorage.removeItem("busTittle");
            localStorage.removeItem('book-again');
            localStorage.removeItem('blog-img');

            localStorage.removeItem("email");
            localStorage.removeItem("phone");
    
         
            localStorage.removeItem('boardingPointLats');
            localStorage.removeItem('boardingPointLongs');
            localStorage.removeItem('dropOffPointLats');
            localStorage.removeItem('dropOffPointLongs');    

            localStorage.removeItem('discount');
            localStorage.removeItem('disPercent');
            localStorage.removeItem('discountBack');
            localStorage.removeItem('disPercentBack'); 
            
            // clear confirm booking
            localStorage.removeItem("boardingPointId");
            localStorage.removeItem("dropOffPointId");
            localStorage.removeItem("boardingPointIdBack");
            localStorage.removeItem("dropOffPointIdBack");
            localStorage.removeItem("gender");

            localStorage.removeItem("selection1");
            localStorage.removeItem("selection2");
            localStorage.removeItem("selection3");
            localStorage.removeItem("selection4");
        },
        
        // Browser back button blocking methods
        blockBrowserBack() {
            if (!this.historyBlocked) {
                // Push a dummy state to history
                window.history.pushState({ blocked: true }, '', window.location.href);
                
                // Create popstate handler
                this.popstateHandler = (event) => {
                    if (!this.isCancelingBooking) {
                        // Push state again to block back navigation
                        window.history.pushState({ blocked: true }, '', window.location.href);
                        
                        // Show confirmation dialog
                        const confirmed = window.confirm(this.$t('message.doyouwanttocancelbooking'));
                        if (confirmed) {
                            this.handleBackNavigation();
                        }
                    }
                };
                
                // Add event listener
                window.addEventListener('popstate', this.popstateHandler);
                this.historyBlocked = true;
            }
        },
        
        unblockBrowserBack() {
            if (this.historyBlocked && this.popstateHandler) {
                window.removeEventListener('popstate', this.popstateHandler);
                this.popstateHandler = null;
                this.historyBlocked = false;
            }
        },
        
        async handleBackNavigation() {
            // Remove the blocker first to prevent infinite loop
            this.unblockBrowserBack();
            
            // Cancel booking and navigate
            const cancelled = await this.cancelBooking({
                skipConfirm: true,
                skipNavigation: true,
                skipHistoryReset: true
            });
            
            if (cancelled) {
                // Replace current history entry and go back
                window.history.replaceState(null, '', '/');
                // Check if already on home page to avoid redundant navigation
                if (this.$route.path !== '/') {
                    this.$router.replace('/').catch(err => {
                        // Ignore navigation duplicated errors
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    });
                }
            } else {
                // If cancel failed, re-enable blocking
                this.blockBrowserBack();
            }
        },
    },
    created() {
        localStorage.setItem('transactionId', this.$route.query.transactionId);
        // this.startTimer();
        this.getPhone();
        this.getCheck();
    },
    mounted() {
        loadScript(this.urlABA);
        
        // Block browser back button
        this.blockBrowserBack();
        
        // Add beforeunload event to warn users about closing tab/window
        window.addEventListener('beforeunload', this.beforeUnloadHandler);
    },
    
    beforeUnloadHandler(event) {
        if (!this.isCancelingBooking) {
            const message = this.$t('message.doyouwanttocancelbooking');
            event.preventDefault();
            event.returnValue = message;
            return message;
        }
    },

    beforeRouteLeave(to, from, next) {
        if(this.isCancelingBooking) {
            this.unblockBrowserBack();
            next();
            return;
        } 

        if (window.confirm(this.$t('message.doyouwanttocancelbooking'))) {
            this.unblockBrowserBack();
            localStorage.removeItem('handleBrowser');
            this.clearStorage();
            next();
        } else {
            next(false);
        }
    },
    unmounted() {
        this.isCancelingBooking = false;
        this.unblockBrowserBack();
        window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    },
}
</script>

<style scoped>
.by-follow a:hover {
    color: #333;
}

.payment {
    padding-top: 100px;
    padding-bottom: 50px;
}

.fare-summary:hover {
    font-size: 14px;
    font-weight: 600;
    color: #1B77F2;
    text-decoration: underline;
    cursor: pointer;
}

.cancel-booking-orderId {
    display: flex;
    align-items: center;
}

.cancel-booking-orderId .cancel-booking {
    width: 50%;
    cursor: pointer;
    font-weight: 600;
    color: #1B77F2;
}

.cancel-booking-orderId .cancel-booking:hover {
    color: #4248e6;
}

.cancel-booking-orderId .orderId {
    /* text-align: end; */
    width: 50%;
}

.cancel-booking-orderId .orderId .order-id-transaction {
    padding-bottom: 15px;

}

.cancel-booking-orderId .orderId .expired-transaction-timeout {
    padding-bottom: 15px;
}

.servicefee {
    position: absolute;
    left: 50%;
    top: 30%;
}

/* right */
.passDetails {
    display: flex;
    align-items: center;
    padding-top: 0%;
}

.passDetails .number {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #312783;
    background: #312783;
}

.passDetails .title-pass {
    /* margin-left: 15px; */
    font-weight: 600;
    font-size: 20px;
    color: #20292F;
}

.select-radio .card-select-payment {
    position: relative;
    background: #EEEEF3;
    margin-top: 20px;
    padding: 17px;
    border-radius: 6px;
    display: flex;
    align-items: center;
}

.select-radio .card-select-payment .text .title {
    font-weight: 600;
    font-size: 12px !important;
    color: #424245;
}

/* .dotted { 
    padding-top: 10px;
} */  

.select-radio .card-select-payment .text .txt {
    font-weight: 400;
    font-size: 12px !important;
    color: #6E6E73;
} 

.select-radio .card-select-payment .img-card {
    width: 10%;
}

.select-radio .card-select-payment .text {
    width: 80%;
}

.select-radio .card-select-payment .radios {
    width: 10%;
    min-width: 36px;
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.select-radio .card-select-payment .radios .payment-radio {
    margin: 0;
    padding: 0;
}

.select-radio .card-select-payment .radios .payment-radio /deep/ .v-input--selection-controls__input {
    margin-right: 0;
}

.select-radio .card-select-payment .radios .payment-radio /deep/ .v-icon {
    color: #C6C6C6 !important;
}

.select-radio .card-select-payment .radios .payment-radio.v-item--active /deep/ .v-icon {
    color: #DE5D0A !important;
}

.summary-left {
    display: none;
}

.small-payment {
    display: none;
}

.button-pay {
    display: none;
}

.button-pay-first {
    display: block;
}

/* .select-radio .card-select-payment .radios {
        display: flex;
        justify-content: end;
        width: 10%;
    } */
@media(width < 960px) {

    .book-pay-now p {
        font-size: 16px;
        font-weight: 500;
    }

    .select-radio {
        padding-left: 0px;
    }

    .select-radio .card-select-payment .text {
        padding-left: 20px;
    }

    .custom-row {
        display: flex;
        flex-direction: column;
    }

    /* Make right column go to top */
    .right-col {
        order: -1;
    }

    /* Optional: make sure the others stay below */
    .left-col {
        order: 1;
        display: none;
    }

    .container-total {
        display: none;
    }

    .summary-left {
        display: block;
    }

    .min-col {
        order: 2;
        display: none;
    }

    .small-payment {
        display: block;
    }

    .button-pay {
        display: block;
    }

    .button-pay-first {
        display: none;
    }

    .payment {
        padding-bottom: 20px;
    }

    .small-screen {
        padding-bottom: 5rem;
    }

    .row img {
        padding: 0%;
    }

    .seat-info.with-border {
        border: 0;
        /* margin-top: 8px; */
        padding-top: 8px;
        background-image: repeating-linear-gradient(to right,
                #c6c6c6 0,
                #c6c6c6 6px,
                transparent 6px,
                transparent 12px);
        background-size: 100% 1px;
        background-repeat: no-repeat;
        background-position: top;
    }

}

@media (width < 457px) {
    .select-radio .card-select-payment {
        padding: 8px;
    }

    .book-pay-now p {
        font-size: 16px;
        font-weight: 500;
    }
}

.row img {
    padding: 0%;
}

@media(width < 435px) {
    .book-pay-now p {
        font-size: 16px;
        font-weight: 500;
    }

    .passDetails .title-pass {
        font-size: 13px;
    }

    .row img {
        padding: 0%;
    }

    .type-payment,
    .text-total {
        width: 40% !important;

    }

    .price-payment,
    .price-total {
        width: 60% !important;
    }
}

/* Left */
.left {
    padding: 1rem;
}

.left .trip-sum {
    color: #20292F;
    font-weight: 600;
    font-size: 16px;
    margin-top: 5px;
}

.trip-sum {
    color: #20292F;
    font-weight: 600;
    font-size: 14px;
    margin-top: 5px;
}

.left .all-info {
    color: #20292F;
    /* font-weight: 600; */
    margin-top: 13px;
    font-size: 14px;
}

.all-info {
    color: #20292F;
    margin-top: 13px;
    /* font-weight: 545; */
    font-size: 14px;
}

.all-payment {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.all-payment .type-payment {
    width: 30%;
}

.all-payment .price-payment {
    width: 70%;
}

.all-payment .price-payment span {
    font-weight: 600;
}

/* container sub total */
.container-total {
    width: 100%;
    padding: 20px 0px 0px 0px;
}

.summary-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    width: 100%;
    max-width: 600px;
}

.summary-grid1 {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    background-color: #fff;
}

.summary-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
}

.summary-label {
    color: #20292F;
    font-weight: 500;
    font-size: 14px;
}

.summary-value {
    text-align: end;
    font-size: 14px;
}

.summary-valuedis {
    width: 26%;
}

.total-amount {
    border-bottom: none;
    font-size: 16px;
}

.toggle-summary {
    color: #1B77F2;
    font-size: 14px;
    margin-left: 8px;
    cursor: pointer;
    display: inline-block;
}

.toggle-summary:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .book-pay-now p {
        font-size: 16px;
        font-weight: 500;
    }

    .summary-grid {
        max-width: 100%;
    }

    .row img {
        padding: 0%;
    }

    .summary-row {
        grid-template-columns: 2fr 3fr;
    }

    .summary-value {
        text-align: end;
        /* font-weight: 600; */
        font-size: 14px;
        color: #20292F;
    }

    .summary-label {
        color: #20292F;
        font-weight: 400;
        font-size: 14px;
    }

    .summary-valuedis {
        /* border-bottom: 1px solid #C6C6C6; */
        width: 100%;
        text-align: end;
        font-weight: 600;
        font-size: 14px;
    }

}

.book-pay-now {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    border-radius: 4px;
    text-align: center;
    padding: 10px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    transition: 0.5s;
    border: 1px solid #DE5D0A;
    color: #fff;
    background: #DE5D0A;
}

/* .book-pay-now p {
    font-size: 16px;
    font-weight: 600;
} */

.payment-frame {
    padding-left: 30px;
    padding-right: 30px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.set-wi-he {
    position: relative;
    width: 600px;
    height: 600px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fare-details {
    margin-top: 10px;
    padding: 10px;
    background-color: #f8f8f8;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.fare-summary {
    cursor: pointer;
    transition: color 0.3s ease;
}

.fare-summary:hover {
    text-decoration: underline;
}

/* ===== ACLEDA Sub-Payment Dialog ===== */
.acleda-dialog {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    font-family: inherit;
}

.acleda-dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #F0F0F0;
}

.acleda-dialog-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 700;
    color: #20292F;
}

.acleda-dialog-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #8C9198;
    font-size: 18px;
    padding: 4px 8px;
    border-radius: 6px;
    transition: background 0.2s, color 0.2s;
    line-height: 1;
}

.acleda-dialog-close:hover {
    background: #F5F5F5;
    color: #20292F;
}

.acleda-dialog-body {
    padding: 16px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* Card style matching card-select-payment */
.acleda-dialog-method-card {
    position: relative;
    background: #EEEEF3;
    padding: 12px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background 0.2s;
}

.acleda-dialog-method-card:hover {
    background: #e2e2ea;
}

.acleda-dialog-img-card {
    width: 10%;
    display: flex;
    align-items: center;
}

.acleda-dialog-img-card img {
    max-width: 40px;
    max-height: 36px;
    object-fit: contain;
}

.acleda-dialog-text {
    width: 82%;
    padding-left: 12px;
}

.acleda-dialog-card-title {
    font-weight: 600;
    font-size: 12px;
    color: #424245;
    line-height: 20px;
}

.acleda-dialog-card-desc {
    font-weight: 400;
    font-size: 12px;
    color: #6E6E73;
    height: 18px;
}

.acleda-dialog-card-desc img {
    height: 100%;
}

.acleda-dialog-arrow {
    width: 8%;
    min-width: 24px;
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #8C9198;
    font-size: 13px;
}
</style>